module.exports = __webpack_public_path__ + "img/mimos_kit_pinceis.7cfada6.webp";